module.exports = __webpack_public_path__ + "img/yellowBg.b9cac710.png";